import { AnyAction } from 'redux';

const namespace = 'ACCOUNT_MANAGEMENT';

export const SET_CURRENT_CUID = `${namespace}/SET_CURRENT_CUID`;

export const setCurrentCUID = (payload: string | null): AnyAction => ({
  type: SET_CURRENT_CUID,
  payload,
});
